/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by GUillermo Castro Reyes <guillermo.castro@ironbit.com.mx>, September 2022
 */
import React from 'react';
import {cls} from 'packages/components';
import {IMatchProps, Match} from './match';
import Utils from 'src/utils/Utils';

export interface IMatchSeparator {
    pipe: string,
    versus: string,
    versusdetail: string,
    hyphen:string
}

export interface IMatchRibbonProps {
    index: number,
    roundId: string,
    phaseName: string,
    separator: IMatchSeparator,
    matches: IMatchProps[]
}
/**
 * A World Cup Matches Ribbon
 */
export class MatchRibbon extends React.Component<IMatchRibbonProps> {
    
    constructor(props: IMatchRibbonProps) {
        super(props);
    }

    componentDidMount() {
        Utils.setInitialFocus(".ribbon-categories.mundial a:nth-child(1)");
    }
    
    render() {
        const {matches, phaseName, roundId, separator, index} = this.props;
        return (
            <div id={`row-${index}`} className='worldcup-match-ribbon'>
                <div className='worldcup-match-phase'>{phaseName}</div>
                <div id={roundId} className={cls('worldcup-matches', roundId)}>
                    {matches.map((match: IMatchProps, columnIndex) => {
                        let navigationUp = index > 0 ? { "data-sn-up": `#row-${index-1}-column-${columnIndex}`} : {};
                        let navigationRight = columnIndex === matches.length - 1 ? {"data-sn-right": ""} : {}; 
                        return (
                            <Match {...match} data={roundId} separator={separator} row={index} column={columnIndex} id={`row-${index}-column-${columnIndex}`} 
                                navigation={{...navigationUp, ...navigationRight}}
                                />)
                    })}
                </div>
            </div>
        )
    }
}

export default MatchRibbon;


// WEBPACK FOOTER //
// ./src/mundial/Tabs/Match/matchRibbon.tsx